import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class GenericService extends AbstractService {
	static vehicleTypesApi = NexusService.vehicleTypesApi;

	static statesApi = NexusService.statesApi;

	static jobEventTypesApi = NexusService.jobEventTypesApi;

	static dressTypesApi = NexusService.dressTypesApi;

	static timeZonesApi = NexusService.timeZonesApi;

	static getUSStates() {
		return this.statesApi.getStates().then(response => {
			const apiResponse = {
				data: response,
			};

			return apiResponse;
		});
	}

	static getTimeZones() {
		if (FeatureFlagService.isEnabled("use_api_core_endpoints_timezones")) {
			return this.timeZonesApi.getTimeZones().then(response => {
				const apiResponse = {
					data: response,
				};

				return apiResponse;
			});
		}
		return this.get({ endpoint: ENDPOINTS.timezones });
	}

	static getJobEventTypes() {
		if (FeatureFlagService.isEnabled("use_api_core_endpoints_job_event_types")) {
			return this.jobEventTypesApi.getJobEventTypes().then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.get({ endpoint: ENDPOINTS.jobEventTypes });
	}

	static getVehicleTypes() {
		return this.vehicleTypesApi.getVehicleTypes().then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}

	static getDressTypes() {
		if (FeatureFlagService.isEnabled("use_api_core_endpoints_dress_types")) {
			return this.dressTypesApi.getDressTypes().then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}

		return this.get({ endpoint: ENDPOINTS.dressTypes });
	}

	static getLocationTypes() {
		return this.get({ endpoint: ENDPOINTS.locationTypes });
	}

	static getTimeZonesForAgencySettings() {
		if (FeatureFlagService.isEnabled("use_api_core_endpoints_timezones")) {
			return this.timeZonesApi.getTimeZoneForAgencySettings().then(response => {
				const apiResponse = {
					data: response,
				};

				return apiResponse;
			});
		}
		return this.get({ endpoint: ENDPOINTS.timezonesForAgencySettings });
	}
}
